import { DELETETEAM_SUCCESS, DELETETEAM_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const removeTeamReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETETEAM_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELETETEAM_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default removeTeamReducer;
